import React from 'react';

import ActorMapContainer from '../../ActorMap/ActorMapContainer.js';

import Translations from '../../../utils/Translations';

const OverviewActorMap = (props) => {

    const {geoLocation, markers} = props;

    return (
        <section className='overview-infobox-container'>
            <p className='context-box__title'>{Translations.get('ActorProfileHomeTitle')}</p>
            <div className='js-actor-map-container actor-profile-overview__map -border'>
                <ActorMapContainer
                    attributionControl = {false}
                    avoidDuplicates    = {false}
                    boxZoom            = {false}
                    className          = {"actor-map"}
                    center             = {geoLocation}
                    disableMapDragging = {true}
                    dragging           = {false}
                    keepCenterOnZoom   = {true}
                    keyboard           = {false}
                    scrollWheelZoom    = {false}
                    markers            = {markers}
                    maxZoom            = {11}
                    minZoom            = {6}
                    tap                = {false}
                    touchZoom          = {false}
                    zoom               = {11}
                    zoomControl        = {true}
                />
            </div>
        </section>
    );

}

export default OverviewActorMap
